<template>
  <div :style="{overflow: overflowVisible ? 'initial' : ''}" :class="{'neu-card': !hideNeuCardClass}" @click="$emit('click', $event)">
    <div :class="baseContainerClass" class="neu-card-title mb-3" v-if="hasTitle || showRightBtn">
      <slot v-if="!title && !showRightBtn" name="title"></slot>
      <h3 v-else-if="!hideTitle" :class="`d-inline-block${titleClass ? ' ' + titleClass : ''}`">
        {{title}}
          <span class="info-container" v-b-tooltip.hover.html="{ title: info, placement: 'top'}">
            <span v-if="info" class="info-text">[Info]</span>
          </span> 
        <!-- Botón en el título -->
        <span v-if="!hideButtons" @click="$emit('rightBtnClick')">
          <slot name="append-btn-title"></slot>
        </span>
      </h3>
      <!-- Botón flotante a la derecha -->
      <div class="float-right" v-if="hasRightButtonSlot && !hideButtons" @click="$emit('rightBtnClick')">
        <slot name="right-button"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'

export default {
  name: 'base-card',
  components: {
    BTooltip
   },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    info: { // Nueva prop para mostrar info
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    titleClass: {
      type: String,
      required: false,
      default: ''
    },
    hideTitle: Boolean,
    overflowVisible: Boolean,
    flowRoot: Boolean,
    marginBottom: {
      type: Number,
      default: 3
    },
    hideNeuCardClass: Boolean,
    hideButtons: Boolean,
    showRightBtn: Boolean
  },
  data () {
    return {
      showInfo: false
    }
  },
  computed: {
    hasTitle () {
      return this.title || this.$slots.title
    },
    hasRightButtonSlot () {
      return !!this.$slots['right-button']
    },
    baseContainerClass () {
      let carFlowRoot = this.flowRoot ? 'card-flow-root' : null
      let marginBottom = `mb-${this.marginBottom}`
      return [carFlowRoot, marginBottom]
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../../../static-appopensalud/css/scss/bootstrap-variables.scss';
  .legend-point {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.period-day {
  background-color: red;
}

.predicted-ovulation-day {
  background-color: orange;
}

.ovulation-day {
  background-color: lightblue;
}
  .neu-card {
    position: relative;
    overflow: hidden;
    box-shadow: $custom-shadow;
    padding: $padding-bg;
    border-radius: $border-radius;
    border: $border;
    background-color: $white;
    @include mobile {
      padding: $padding-md;
    }
  }

  .neu-card-title {
    .btn {
      margin-top: 0px !important;
    }
  }

  .info-container {
    position: relative;
    margin-left: 10px;
  }

  .info-text {
    cursor: pointer;
    color: $blue;
    text-decoration: underline;
    font-size: 13px;
  }

  .info-bubble {
    background-color: #f5f5f5 !important;  /* Color de fondo */
    border: 1px solid #ddd !important;     /* Borde */
    border-radius: 5px !important;         /* Bordes redondeados */
    padding: 5px 10px !important;          /* Espaciado interno */
    font-size: 14px !important;            /* Tamaño del texto */
    color: #333 !important;                /* Color del texto */
    max-width: 300px;                      /* Ancho máximo, ajustable */
    word-wrap: break-word;   
  }

  .tooltip .b-tooltip {
    position: absolute;
    background-color: #f5f5f5 !important;  /* Cambiar el color del fondo del tooltip */
    color: #333 !important;                /* Cambiar el color del texto del tooltip */
    border: 1px solid #ddd !important;     /* Borde personalizado */
    padding: 5px 10px !important;          /* Espaciado */
    font-size: 14px !important;            /* Tamaño de texto */
    max-width: 300px !important;           /* Ancho máximo */
    word-wrap: break-word !important;
}
  
  .card-flow-root {
    display: flow-root;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/ui/BaseCard.vue